<span [class]="classnames">{{ name }}</span>
